import { render } from "./AdminRoster.vue?vue&type=template&id=4f39d1a4&scoped=true&lang=pug"
import script from "./AdminRoster.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRoster.vue?vue&type=script&setup=true&lang=js"

import "./AdminRoster.vue?vue&type=style&index=0&id=4f39d1a4&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f39d1a4"]])

export default __exports__